import {validationLength} from "constants/validationLength";

/**
 * @param {string} value
 * @param {boolean} required
 * @param {'small' | 'medium' | 'large'} length
 * @return {string}
*/
const validateExplanationField = (value, required = false, length = 'extraLarge') => {
    if (value.trim().length > validationLength[length]) {
        return `Text is too long (maximum is ${validationLength[length]} characters)`;
    }

    if (required && !value.trim()) {
        return 'Required';
    }

    return '';
};

export default validateExplanationField;
